import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Mask = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="mask icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C2.93961 0 2 0.939613 2 2V14C2 19.567 6.43295 24 12 24C17.567 24 22 19.567 22 14V2C22 0.939613 21.0604 0 20 0H4ZM5.81882 10.2989C5.60317 10.4565 5.43095 10.5824 5.23451 10.5566C5.00932 10.5388 4.81772 10.1586 4.80018 9.61142C4.78274 8.01847 5.89974 6.68509 7.20544 6.7207C8.52539 6.76098 9.59893 8.06499 9.59932 9.59636C9.61305 10.161 9.4112 10.5244 9.16029 10.5542C8.90471 10.578 8.69294 10.4293 8.44607 10.2558C8.13575 10.0378 7.76997 9.78086 7.19198 9.77877C6.51809 9.78793 6.12475 10.0754 5.81882 10.2989ZM14.8383 10.542C15.0366 10.5756 15.2098 10.4521 15.4297 10.2953C15.7326 10.0794 16.1242 9.80021 16.7921 9.78098C17.3774 9.77335 17.7488 10.0378 18.0617 10.2606C18.3057 10.4343 18.5141 10.5827 18.7607 10.5571C19.0116 10.5272 19.2095 10.181 19.1996 9.59847C19.2031 8.04855 18.1476 6.73081 16.8056 6.72069C15.4998 6.68506 14.379 8.03685 14.4003 9.61357C14.4215 10.1438 14.6132 10.5243 14.8383 10.542ZM12.0044 20.16C9.04863 20.1296 6.61533 18.2246 5.80259 15.2064C5.63471 14.65 5.98265 14.2523 6.50106 14.4607C8.22119 15.1692 10.3824 15.3668 12 15.36C13.5841 15.3753 15.7308 15.1845 17.4719 14.4667C17.9934 14.2363 18.3697 14.6289 18.1979 15.2437C17.3965 18.2536 14.9875 20.1337 12.0044 20.16Z"
    />
  </svg>
)
